import { jwtDecode } from 'jwt-decode';

const getCookieValue = (name) => {
  console.log('Getting cookie value for ', name)
  console.log("All cookies:", document.cookie);

  const match = document.cookie.match(
    new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)')
  );
  return match ? decodeURIComponent(match[1]) : null;
};

const tokenExpired = (token) => {
  if (!token) {
    console.log('No token to check, returning true')
    return true;
  }

  let decoded;
  try {
    decoded = jwtDecode(token);
  } catch {
    console.log('Error decoding token')
    return true;
  }

  if (!decoded.exp) {
    console.log('No exp value, returning true')
    return true;
  } 

  return Date.now() / 1000 > decoded.exp;
};

export {
  getCookieValue,
  tokenExpired,
}
